import React from 'react';
import { AppState } from '@om-fe/core/core/types';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { bemSlider } from '@om-fe/widgets/dist/components/slider/slider.constants';
import { BemModifier } from '@om-fe/utils';
import { DisciplineIcon } from '@om-fe/widgets/dist/components/icon/discipline-icon';
import { FlagIcon } from '@om-fe/widgets/dist/components/icon/flag-icon';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { TournamentParams, DisciplinesType } from '@om-fe/models';
import { getTopBetSliceName } from './nav.utils';
import { connect } from 'react-redux';
import { NavListItemModel, NavListStateModel } from './nav.reducer';
import getSlice from '@om-fe/core/utils/get-slice';
import { TopBetsTab } from '../../utils/top-bets.constants';
import getConfig, { LocationNavConfig } from '@om-fe/core/utils/config';

type NavItemBaseRouteParams = 'disciplineName' | 'disciplineId' | 'sportLocationName' | 'sportLocationId' | 'activeTab';

export type NavItemRouteParamsMap = Record<NavItemBaseRouteParams, string>;

interface NavItemPublicProps {
    readonly id: string;
    readonly instanceId: string;
    readonly activeTab?: string;
    readonly routeName: string;
    readonly routeParamsMap?: NavItemRouteParamsMap;
    readonly handleTournamentParams?: (params: TournamentParams) => void;
    readonly preventRedirect?: boolean;
    readonly noRedirectFilter?: (genericId?: string) => void;
    readonly genericId?: string;
    readonly isCategory?: boolean;
    readonly disciplineId?: string;
    readonly extraClassName?: string;
}

interface NavItemProps {
    readonly navItem?: NavListItemModel;
}

type NavListItemProps = NavItemProps & NavItemPublicProps;

function NavItemComponent  (
{
    id,
    navItem,
    routeName,
    preventRedirect,
    noRedirectFilter,
    activeTab,
    isCategory,
    disciplineId,
}: NavListItemProps) {
    const { gettext } = useI18NContext();
    const locationNavConfig: LocationNavConfig | undefined = getConfig().locationNavConfig;
    const displayLocationName: boolean = locationNavConfig?.displayLocationName ?? true;
    const displayShortName: boolean = locationNavConfig?.displayShortName ?? true;
    const displayFlagIcon: boolean = locationNavConfig?.displayFlagIcon ?? true;

    if (id === TopBetsTab.TopBets) {

        return (
            <Anchor
                extraClassName={bemSlider('Action')}
                activeClassName={BemModifier.Active}
                routeName={routeName}
                isActive={activeTab === TopBetsTab.TopBets}
                preventRedirect={preventRedirect}
                handleClickAnchor={() => preventRedirect && noRedirectFilter ? noRedirectFilter(TopBetsTab.TopBets) : null }
            >
                <div className={bemSlider('ItemText')}>
                    {gettext('Popular')}
                </div>
            </Anchor>
        );
    }

    if (id === TopBetsTab.All) {

        return (
            <Anchor
                extraClassName={bemSlider('Action')}
                activeClassName={BemModifier.Active}
                routeName={routeName}
                isActive={activeTab ===  TopBetsTab.All}
                preventRedirect={preventRedirect}
                handleClickAnchor={() => preventRedirect && noRedirectFilter ? noRedirectFilter( TopBetsTab.All) : null }
            >
                <div className={bemSlider('ItemText')}>
                    {gettext('All')}
                </div>
            </Anchor>
        );
    }

    if (!navItem) {
        return null;
    }

    return (
        <Anchor
            extraClassName={bemSlider('Action')}
            activeClassName={BemModifier.Active}
            routeName={routeName}
            isActive={activeTab === id}
            preventRedirect={preventRedirect}
            handleClickAnchor={() => preventRedirect && noRedirectFilter ? noRedirectFilter(id) : null }
        >
            {disciplineId && disciplineId === DisciplinesType.ElectronicSports && id && displayFlagIcon && (
                <div className={bemSlider('ItemIcon')}>
                    <DisciplineIcon disciplineId={id} />
                </div>
            )}
            {(!disciplineId || disciplineId !== DisciplinesType.ElectronicSports) && id && displayFlagIcon && (
                <div className={bemSlider('ItemIcon')}>
                    <FlagIcon locationId={isCategory ? '240' : id} />
                </div>
            )}
            {displayLocationName &&
                <div className={bemSlider('ItemText')}>
                    {displayShortName && navItem.shortName ? navItem.shortName : navItem.name}
                </div>
            }
        </Anchor>
    );
};

const NavItem: React.ComponentType<NavItemPublicProps> = connect(
    (state: AppState, { id, instanceId }: NavItemPublicProps): NavItemProps => {
        const sliceName: string = getTopBetSliceName(instanceId);
        const slice: NavListStateModel | undefined = getSlice<NavListStateModel>(state, sliceName);

        if (!slice) {
            return {};
        }

        return ({
            navItem: id !==  TopBetsTab.TopBets && id !==  TopBetsTab.All ? slice.items[id] : undefined,
        });
    },
)(NavItemComponent);
export default NavItem;